export default "__VITE_ASSET__1mbtRqwq__";